import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentApplication } from 'src/app/model/agent.application';

@Component({
    selector: 'app-last-child-agent',
    templateUrl: './last-child-agent.component.html',
    styleUrls: ['./last-child-agent.component.css'],
})
export class LastChildAgentComponent {
    @Input() agentApplication: AgentApplication;
    @Output() status = new EventEmitter<{ type: string; agentApplication: AgentApplication }>();

    constructor() { }

    changeStatus(val: string) {
        this.status.emit({ type: val, agentApplication: this.agentApplication });
    }
}
